import fetch from 'cross-fetch'
import queryString from 'query-string'
import AppSettings from '../config'

export const fetchGetSystemStatus = () => 
  (key:any, params:any) =>
    fetch(`${AppSettings.SYSTEM_STATUS_URL}/api/v1/incidents?${queryString.stringify(params, { arrayFormat: 'bracket' })}`, {
      method: 'GET'
    }).then(res => res.json())
